// btoa/atob work on "binary strings": one UTF-16 code unit per byte.

export function bytesToBase64(bytes: ArrayBuffer | ArrayBufferView): string {
  // isView (not instanceof) also recognizes views created in another realm.
  const view = ArrayBuffer.isView(bytes)
    ? new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength)
    : new Uint8Array(bytes);
  let binary = "";
  for (const byte of view) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary);
}

/**
 * Decode base64. Whitespace is ignored, which matters for the server's client keys: Ruby's
 * Base64.encode64 wraps them with newlines.
 */
export function base64ToBytes(base64: string): Uint8Array<ArrayBuffer> {
  return Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
}
